import React from 'react'
import PropTypes from 'prop-types'
import {Field, reduxForm, SubmissionError} from 'redux-form'
import {Link} from 'react-router'
import FormInput from 'components/FormInput'
import {forgotPassword} from 'redux/modules/currentUser/actions'
import isEmail from 'validator/lib/isEmail'
import Button from 'components/Button'
import Icon from 'components/Icon'

class ForgotForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool
  }

  render() {
    const {handleSubmit, invalid, submitting} = this.props

    return (
      <div className='auth-view_content is-single'>
        <div className='auth-view_panel is-restore'>
          <form className='auth-view_form is-forgot' onSubmit={handleSubmit}>
            <div className='auth-view_title'>Forgot your password?</div>
            <div className='auth-view_subtitle'>
              We’ll get you back into your account ASAP! Just tell us what email you used to signup.
            </div>
            <Field
              name='email'
              placeholder='Your email'
              disabled={submitting}
              component={FormInput}
            />
            <Button disabled={invalid || submitting} color='green' type='submit'>
              Restore password
              <Icon className='auth-view_form_button_icon' name='arrow-button' size='23px' />
            </Button>
          </form>
          <p className='auth-view_panel_text is-login'>
            Remembered your password?{' '}<Link className='auth-view_panel_text_link' to='/login'>Login</Link>
          </p>
        </div>
      </div>
    )
  }
}

export default reduxForm({
  form: 'forgot',
  validate: ({email}) => {
    const errors = {}

    if (!email) {
      errors.email = 'Email is required'
    } else if (!isEmail(email)) {
      errors.email = 'Incorrect email address'
    }

    return errors
  },
  onSubmit: ({email}, dispatch) => new Promise((resolve, reject) => {
    dispatch(forgotPassword(email))
      .success(resolve)
      .fail(err => reject(new SubmissionError({_error: err.message})))
  })
})(ForgotForm)



// WEBPACK FOOTER //
// ./client/views/AuthView/ForgotForm.js